import React from 'react';
import partnerBanner from '../img/envision/aboutdd/pppss.JPG';
import AboutPartnersbanner from './AboutPartnersbanner';
import Aboutpatnersectionfirst from './Aboutpatnersectionfirst';
import Aboutwithparthers from './Aboutwithparthers';
import RequestForm from './RequestForm';

const AboutParnerspage = () => {
    return (
        <div >
            <AboutPartnersbanner />
           <Aboutpatnersectionfirst />
           <Aboutwithparthers />
           {/* <RequestForm /> */}
        </div>
    );
};

export default AboutParnerspage;
